export enum PerfilNormalizado {
    Responsavel = 'RESPONSAVEL',
    Cadastro = 'CADASTRO',
    Administrativo = 'ADMINISTRATIVO',
    Financeiro = 'FINANCEIRO',
    Beneficio = 'PRODUTO',
    Pedido = 'COMPRA',
    CartaoFisico = 'CARTAOFISICO',
    Relatorio = 'RELATORIO'
}
